/** 课程中心-商品管理 **/

export const formValidate = {
  isLimitEnroll: 0,
  schoolId: '', // 学校
  schoolName: '', // 学校名字
  branchId: '', // 校区
  courseId: '', // 课程 539123686830231552
  courseName: '', // 课程名称 计算机
  termId: '', // 学期
  classroomName: '', // 商品名称
  // courseTypeId: '651067815259889664', // 课程分类
  courseTypeId: [], // 课程分类
  classroomTotal: '', // 累计课时
  classTime: '', // 单节时长
  fee: '', // 课程价格
  classDateBegin: '', // 预计开课日期
  classDateEnd: '', // 预计结束日期,
  classroomTimeDesc: '', // 预计上课时间
  classroomTimeSet: 1, // 预计上课时间设置
  classTimeSame: ['', ''], // 每天上课时间相同
  reqRoomCount: null, // 教室个数
  enrollTimeEnd: '', // 报名截止时间
  studentTotal: '', // 最大报名人数
  visibleDTOList: [], // 报名范围
  enableRefund: 0, // 退款申请许可
  // refundDeadline: '', // 申请时间限制
  isPreEnroll: 0, // 是否预报名
  // payBeginTime: '', // 缴费时间
  // payDeadline: '', // 缴费过期时间
  visibleType: 1, // 列表是否可见
  classroomState: 0, // 商品是否上架
  gradeMin: 1,
  gradeMax: 12,
  teacherIds: '',
  courseClassExtAddRO: {
    courseCover: '0', // 课程封面 :默认封面id 0
    context: '', // 课程介绍
    courseAchievement: '', // 成功展示
    courseNotice: '', // 报名须知
    visibleType: 1, // 列表可见范围：0：不可见 1：可见 2：指定范围可见
    enableRefund: 0, // 退款申请许可：1：允许 0：不允许
    refundDeadline: '', // 退款截止时间
    payBeginTime: '', // 可缴费时间
    payDeadline: '', // 缴费截止时间
    classroomTimeDesc: '', // 预计上课时间说明
    // suitableGrade: '', // 适合年级 格式：1-N 1/3/5
    isPreEnroll: 0, // 是否预报名：1：是 0：否
    schBranchId: '' // 校区id
  },
  reqAttachmentType: 0, // 0:不需要 1：必要 2：非必要
  attachmentPrice: '', // 材料费用
  attachmentDescribe: '' // 材料说明
};
export const resetFormValidate = {
  schoolId: '', // 学校
  schoolName: '', // 学校名字
  branchId: '', // 校区
  courseId: '', // 课程 539123686830231552
  courseName: '', // 课程名称 计算机
  termId: '', // 学期
  classroomName: '', // 商品名称
  // courseTypeId: '651067815259889664', // 课程分类
  courseTypeId: [], // 课程分类
  classroomTotal: '', // 累计课时
  classTime: '', // 单节时长
  fee: '', // 课程价格
  classDateBegin: '', // 预计开课日期
  classDateEnd: '', // 预计结束日期,
  // classroomTimeDesc: '', // 预计上课时间
  classroomTimeDesc: '', // 预计上课时间
  classroomTimeSet: 1, // 预计上课时间设置
  reqRoomCount: null, // 教室个数
  classTimeSame: [], // 每天上课时间相同
  enrollTimeEnd: '', // 报名截止时间
  studentTotal: '', // 最大报名人数
  visibleDTOList: [], // 报名范围
  enableRefund: 0, // 退款申请许可
  // refundDeadline: '', // 申请时间限制
  isPreEnroll: 0, // 是否预报名
  // payBeginTime: '', // 缴费时间
  // payDeadline: '', // 缴费过期时间
  visibleType: 1, // 列表是否可见
  classroomState: 0, // 商品是否上架
  gradeMin: 1,
  gradeMax: 12,
  teacherIds: '',
  courseClassExtAddRO: {
    courseCover: '0', // 课程封面 :默认封面id 0
    context: '', // 课程介绍
    courseAchievement: '', // 成功展示
    courseNotice: '', // 报名须知
    visibleType: 1, // 列表可见范围：0：不可见 1：可见 2：指定范围可见
    enableRefund: 0, // 退款申请许可：1：允许 0：不允许
    refundDeadline: '', // 退款截止时间
    payBeginTime: '', // 可缴费时间
    payDeadline: '', // 缴费截止时间
    classroomTimeDesc: '', // 预计上课时间说明
    // suitableGrade: '', // 适合年级 格式：1-N 1/3/5
    isPreEnroll: 0, // 是否预报名：1：是 0：否
    schBranchId: '' // 校区id
  },
  reqAttachmentType: 0, // 0:不需要 1：必要 2：非必要
  attachmentPrice: '', // 材料费用
  attachmentDescribe: '' // 材料说明
};
export const formValidate2 = {
  courseInfo: '', // 课程介绍
  bookRules: '' // 报名须知
};
export const ruleValidate = {
  schoolId: [{ required: true, message: '请选择学校', trigger: 'blur' }],
  branchId: [{ required: true, message: '请选择校区', trigger: 'change' }],
  courseId: [{ required: true, message: '请选择课程', trigger: 'blur' }],
  termId: [{ required: true, message: '请选择学期', trigger: 'change' }],
  courseTypeId: [
    {
      required: true,
      type: 'array',
      message: '请选择课程分类',
      trigger: 'change'
    }
  ],
  classroomName: [
    { required: true, message: '请填写商品名称', trigger: 'change' }
  ],
  classroomTotal: [
    { required: true, validator: validateClassHours, trigger: 'blur' }
  ],
  classTime: [{ validator: validateClassMinuts, trigger: 'blur' }],
  fee: [{ required: true, validator: validateCoursePrice, trigger: 'change' }],
  reqAttachmentType: [{ required: true }],
  attachmentPrice: [
    { required: true, validator: validateCoursePrice, trigger: 'blur' }
  ],
  attachmentDescribe: [
    { required: true, message: '请填写材料名称', trigger: 'blur' }
  ],
  enrollTimeEnd: [
    {
      required: true,
      message: '请选择报名截止时间',
      trigger: 'change',
      type: 'date'
    }
  ],
  studentTotal: [{ validator: validateBookNum, trigger: 'change' }],
  // visibleDTOList: [
  //   {
  //     required: true,
  //     type: 'array',
  //     min: 1,
  //     message: '请选择报名范围',
  //     trigger: 'change'
  //   }
  // ],
  enableRefund: [{ required: true }],
  refundDeadline: [{ validator: validateApplyTimeLimit, trigger: 'blur' }],
  classroomState: [{ required: true }],
  isPreEnroll: [{ required: true }]
};
export const ruleValidate2 = {
  courseInfo: [{ required: true, message: '请填写课程介绍', trigger: 'blur' }],
  bookRules: [{ required: true, message: '请填写报名须知', trigger: 'blur' }]
};
export const likeGradesList = [
  {
    id: 1,
    name: '一年级'
  },
  {
    id: 2,
    name: '二年级'
  },
  {
    id: 3,
    name: '三年级'
  },
  {
    id: 4,
    name: '四年级'
  },
  {
    id: 5,
    name: '五年级'
  },
  {
    id: 6,
    name: '六年级'
  },
  {
    id: 7,
    name: '初一'
  },
  {
    id: 8,
    name: '初二'
  },
  {
    id: 9,
    name: '初三'
  },
  {
    id: 10,
    name: '高一'
  },
  {
    id: 11,
    name: '高二'
  },
  {
    id: 12,
    name: '高三'
  }
];
export const bookTableColumns = [
  {
    title: '可报名年级'
  },
  {
    title: '年级人数限制'
  },
  {
    title: '可报名班级'
  },
  {
    title: '班级人数限制'
  }
];
// 详情回显
export const TableColumns = [
  {
    title: '所属校区'
  },
  {
    title: '可报名年级'
  },
  {
    title: '年级人数限制'
  },
  {
    title: '可报名班级'
  },
  {
    title: '班级人数限制'
  }
];

// 课时规则
export function validateClassHours(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入课时'));
  } else if (!Number.isInteger(+value) || value < 1) {
    callback(new Error('请输入大于或等于1的整数'));
  } else {
    callback();
  }
}
// 限制时间规则
export function validateApplyTimeLimit(rule, value, callback) {
  if (this.timeLimitStu === 1 && value === '') {
    callback(new Error('请选择退款截止时间'));
  } else {
    callback();
  }
}
// 单节时长规则
export function validateClassMinuts(rule, value, callback) {
  if (!Number.isInteger(+value) || value < 0) {
    callback(new Error('请输入大于或等于0的整数'));
  } else {
    callback();
  }
}
// 课程价格规则
export function validateCoursePrice(rule, value, callback) {
  console.log('拿到的值=====', rule, value);
  let length = 0;
  const arr = value.split('.');
  if (arr.length === 2) {
    length = arr[1].length;
  }
  if (value === '') {
    callback(new Error('请输入价格'));
  } else if (Number.parseFloat(value) < 0) {
    callback(new Error('请输入大于或等于0的金额'));
  } else if (length > 2) {
    callback(new Error('请输入最多两位小数的金额'));
  } else if (arr.length > 2) {
    callback(new Error('请输入一个小数点'));
  } else {
    callback();
  }
}
// 最大报名人数规则
export function validateBookNum(rule, value, callback) {
  if (!Number.isInteger(+value) || value < 0) {
    callback(new Error('请输入大于或等于0的整数'));
  } else {
    callback();
  }
}
// 推荐报名年级数据转化
export function changeLikeGrades(data) {
  const arr1 = data.split('/');
  const arr2 = [];
  arr1.forEach((item) => {
    if (item.length === 1) {
      arr2.push(parseInt(item));
    } else {
      const arr3 = item.split('~');
      for (let i = arr3[0]; i <= arr3[1]; i++) {
        arr2.push(parseInt(i));
      }
    }
  });
  return arr2;
}
